<template>
  <div class="region-chart">
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="编号"
          width="200">
          <template slot-scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          prop="text"
          label="区域填答">
          <template slot-scope="scope">{{scope.row}}</template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'regionChart',
  props: ['quesInfo'],
  computed: {
    tableData() {
      return this.quesInfo.textList
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/singleAnalysis/regionChart.vue